import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { Constant } from 'projects/Autofacets-Core/src/app/utils/constant';
import { Utility } from 'projects/Autofacets-Core/src/app/utils/utility';
import { UserDataService } from 'src/app/DataServices/user-data.service';
import { DealerMechanicAssociationHistory, EditMechanicList } from '../../../business-entities/mechanicList-model';
import { SelectListItemViewModel } from '../../../business-entities/select-list-item-view-model';
import { MechanicService } from '../../../business-services/mechanic.service';
import * as Enums from './../../../../../../Autofacets-Core/src/app/utils/enums';
import { Features } from '../../../business-entities/user-role-view-model';
import { SecureStorage } from 'projects/Autofacets-Core/src/app/common-services/SecureStorage.service';

@Component({
  selector: 'app-edit-basic-details-mechanic',
  templateUrl: './edit-basic-details-mechanic.component.html'
})
export class EditBasicDetailsMechanicComponent implements OnInit {
  mechanicInfo: EditMechanicList;
  dealerMechanicAssociationHistory:DealerMechanicAssociationHistory[];
  editMechanic = false;
  editMechanicForm: FormGroup;
  id: number;
  dealerList: Array<SelectListItemViewModel>;
  dealerId: string;
  dropdownSettings = {};
  NotAvailableEndDate:any;
  mechanicNotAvilable:boolean=false;
  isDmsMechanicIdUsed: boolean = false;
  featureList: Features[] = [];
  isCustomerWaitingSlotsEnabled:boolean = false;

  constructor(private service: MechanicService,
    private formBuilder: FormBuilder,
    private spinner: NgxSpinnerService,
    private toaster: ToastrService, private translate: TranslateService,
    private userService: UserDataService,
    private activeModal : NgbActiveModal,
    private secureStorage: SecureStorage
  ) { }

  ngOnInit(): void {
    this.isDmsMechanicIdUsed = localStorage.getItem('Theme') === 'mg';
    this.service.isEdit = true;
    this.editMechanicForm = this.formBuilder.group({
      name: [{ value: ''}, [Validators.required]],
      isActive: [false],
      adUserId: ['',[Validators.required]],
      adEmail: [{value: ''}, [Validators.required, Validators.pattern(Enums.RegexKeyCollection.Email)]],
      employeeNo: [{ value: '', disabled: !this.isDmsMechanicIdUsed }],
      dmsMechanicNo: [{ value: '', disabled: !this.isDmsMechanicIdUsed }],
      createdBy: [''],
      updatedBy: [''],
      updatedDate: [''],
      dealerId: ['',[Validators.required]],
      dealerName: [''],
      createdDate: [{ value: '', disabled: true }],
      adZIdent: [''],
      isCapacityPlanning:[false],
      isConsiderCustomerWaitingSlots:[true],
      isNotAvailable:[false]
    });
    this.featureList = this.secureStorage.getKeyData('feature');
    this.isCustomerWaitingSlotsEnabled = this.featureList.find(x=>x.featureCode == 'CustomerWaitingSlot')?.isActive ?? false;
    this.getAllData();

  }

  async getAllData() {
    this.dealerList  = this.mapdealer(this.service.dealerList);
    this.id = this.service.mechanicId;
    await this.GetMechanicById(this.id);
  }
  mapdealer(array: any){
    let supperArray = [];
    if (array && array.length > 0) {

      array.forEach(element=>{
        let single = Object();
        single.value = element.value
        single.text = element.text

        supperArray.push(single);
      })
    }
    return supperArray;
  }
  private async GetMechanicById(Id: number) {
    this.spinner.show();

    await this.service.GetMechanicById(Id).then(result => {
      if (result.responseCode === Enums.ErrorCodes.SuccessCode) {
        this.mechanicInfo = result.responseObject?.mechanicUserViewModel;
        this.service.isConsiderCustomerWaitingSlots$.next(this.mechanicInfo?.isConsiderCustomerWaitingSlots ?? null);
        this.dealerMechanicAssociationHistory=result.responseObject?.dealerMechanicAssociationHistory;
        this.dealerMechanicAssociationHistory.forEach((x)=>{
          x.startDate = Utility.ConvertUTCDateToLocalDate(new Date(x.startDate+"Z"))
          x.endDate = Utility.ConvertUTCDateToLocalDate(new Date(x.endDate+"Z"))
        })
        this.dealerId = this.mechanicInfo.dealerId;
        this.mechanicInfo.notAvailableEndDate = this.mechanicInfo.notAvailableEndDate? Utility.GetFormattedDateTime(Utility.ConvertUTCDateToLocalDate(this.mechanicInfo.notAvailableEndDate)):null;
        this.mechanicNotAvilable = this.mechanicInfo?.isNotAvailable
        let dealerFlag = this.dealerList.some(x => x.value ===  result.responseObject?.mechanicUserViewModel.dealerId);
        if (dealerFlag) {
          this.editMechanicForm.patchValue({
            ... result.responseObject?.mechanicUserViewModel,
            dealerName:  this.mechanicInfo?.dealerId ? this.dealerList.find(x => x.value ===  this.mechanicInfo?.dealerId).text : '',
            isCapacityPlanning:result.responseObject?.mechanicUserViewModel.isCapacityPlanning,
            isConsiderCustomerWaitingSlots:result.responseObject?.mechanicUserViewModel.isConsiderCustomerWaitingSlots,
            isNotAvailable:this.mechanicInfo.isNotAvailable,
          })
        }
        else {
          this.editMechanicForm.patchValue({
            ... result.responseObject?.mechanicUserViewModel,
            dealerName: ''
          })
        }

        if(result.responseObject?.mechanicUserViewModel.isTeamLead)
        {
          this.editMechanicForm.controls['isCapacityPlanning'].disable();
        }
        else
        {
          this.editMechanicForm.controls['isCapacityPlanning'].enable();
        }


      }
      if (result.responseObject.result && result.responseObject.result.errorCode === Enums.ErrorCodes.MechanicCode) {
        let errorMessage = this.translate.instant("lblMechanicNotFound");
        this.toaster.error(errorMessage);
      }
      this.spinner.hide();
    },
    _error => {
        this.spinner.hide()
      });
  }
  onDealerSelected(dealerId: string) {
    this.dealerId=  dealerId ?? undefined;
    if(this.dealerId!==undefined)
    {
      this.editMechanicForm.patchValue({
        dealerName:  dealerId
      });
    }
  }
  async EditMechanicBasicDetail(isSaveAndClose) {
    let successMessage = this.translate.instant("lblMechanicDetailsAreEdited");
    let errorMessage = this.translate.instant("lblMechanicDetailsAreNotEdited");
    let userLimitError = this.translate.instant('lblMichanicCreationLimitExceed');
    let mechanicEmailExist = this.translate.instant('lblMechanicEmailExists');
    let warningMessage = this.translate.instant("lblErrorWarningForValue");
    let duplicateDmsMechanicId = this.translate.instant('lblDuplicateDmsMechanicId');
    this.spinner.show();
    let currentUser = this.userService.currentUserValue.id;
    let mechanicId = this.service.mechanicId;
    let localEndDateTime=Utility.getDateStringToDateTimeForMechanic(this.mechanicInfo.notAvailableEndDate);
    let NotAvailEndDate = localEndDateTime ? Utility.ConvertLocalDateToUTCDate(localEndDateTime):localEndDateTime;
    if(!this.mechanicNotAvilable && this.mechanicInfo?.isNotAvailable){
      if(localEndDateTime && localEndDateTime.getTime() < new Date().getTime())
      {
        let errorMessage = this.translate.instant("lblEndDateTimeMustbeGreaterThanCurrentTime");
        this.toaster.error(errorMessage);
        this.spinner.hide();
        return;
      }
    }

    const viewModel: EditMechanicList = {
      ...this.editMechanicForm.value,
      id: mechanicId,
      name: this.cpf.name.value,
      employeeNo: this.cpf.employeeNo.value,
      dmsMechanicNo: this.cpf.dmsMechanicNo.value,
      isActive: this.mechanicInfo.isActive,
      dealerId: this.dealerId,
      adUserId: this.cpf.adUserId.value,
      updatedBy: currentUser,
      adEmail:this.cpf.adEmail.value,
      userId:this.mechanicInfo.userId,
      isCapacityPlanning:this.mechanicInfo.isCapacityPlanning,
      isConsiderCustomerWaitingSlots:this.mechanicInfo.isConsiderCustomerWaitingSlots,
      isNotAvailable:this.mechanicInfo.isNotAvailable,
      NotAvailableEndDate:NotAvailEndDate,
      dmsSyncDate: this.mechanicInfo.dmsSyncDate,
      dmsSyncStatus: this.mechanicInfo.dmsSyncStatus
    };

    let isMechanicValid = true;
    // used to validate duplicate mechanic id for MG tenant
    if (this.isDmsMechanicIdUsed && this.mechanicInfo.dmsMechanicNo != viewModel.dmsMechanicNo) {
      this.spinner.show();
      // validate dms id
      await this.service.ValidateDmsMechanicId(viewModel.id, viewModel.dmsMechanicNo).then(res => {
        this.spinner.hide();
        isMechanicValid = res;
        if (!isMechanicValid) {
          this.toaster.error(duplicateDmsMechanicId);
        }
      }, error => {
        isMechanicValid = false;
        this.spinner.hide();
        if (error.status === Constant.BadRequest) {
          this.toaster.warning(warningMessage);
        }
        else {
          this.toaster.error(errorMessage);
        }
      }).finally(() => {
        this.spinner.hide();
      });
    }

    if (isMechanicValid) {
      this.spinner.show();
      this.service.UpdateMechanic(viewModel).then(async res => {
        this.spinner.hide();
        let result = res.responseObject;
        if (result.errorCount && result.errorCount > 0) {
          let errorResponse = result.result;
  
        if(errorResponse.errorCode === Enums.ErrorCodes.UserCreationLimitExceed){
          this.toaster.error(userLimitError);
        }
        if(errorResponse.errorCode === Enums.ErrorCodes.MechanicEmailExistsCode){
          this.toaster.error(mechanicEmailExist + ' ' + errorResponse.errorMessage);
        }
      }
      else if(res.responseObject === Constant.EditMechanicAdUserIdAlreadyExists && res.responseCode === Constant.SuccessResponseCode){
        //GUID already exists
        let errormsg = this.translate.instant("lblAdGUIDAlreadyExists");
        this.toaster.error(errormsg);
      }
      else if(res.responseObject === Constant.EditMechanicAdEmailIdAlreadyExists && res.responseCode === Constant.SuccessResponseCode){
        //AdEmail Id already exists
        let errormsg = this.translate.instant("lblAdEmailAlreadyExists");
        this.toaster.error(errormsg);
      }
      else if(res.responseObject === Constant.MechanicIsActiveError && res.responseCode === Constant.SuccessResponseCode)
      {
        //Can not update isActive to false as there are active appointment of mechanic
        let errormsg = this.translate.instant("lblMechanicInActiveError");
        this.toaster.error(errormsg);
      }
      else if(res.responseObject === Constant.CapacityChangesError && res.responseCode === Constant.SuccessResponseCode)
      {
        //Can not update Capacity Flag to false as there are active appointment of mechanic
        let errormsg = this.translate.instant("lblMechanicCapacityUpdateError");
        this.toaster.error(errormsg);
      }
      else if(res.responseObject === Constant.DealerChangeError && res.responseCode === Constant.SuccessResponseCode)
      {
        //Dealer Can't change as there are active appointment of mechanic with dealer
        let errormsg = this.translate.instant("lblMechanicDealerAssociationChangeError");
        this.toaster.error(errormsg);
      }
      else if (res.responseCode === Constant.SuccessResponseCode) {
  
          if(res.responseObject === Constant.DetailsUpdatedAndPlanningAvailable)
          {
            let warningMessage = this.translate.instant("lblDetailsAreUpdatedAndMechanicPlanningAvailable");
            this.toaster.warning(warningMessage);
          }
          else
          {
            this.toaster.success(successMessage);
          }
          
          await this.GetMechanicById(this.id);
  
          localStorage.setItem('lastMechanic', JSON.stringify(this.mechanicInfo));
          this.spinner.hide();
          if (isSaveAndClose)
           this.activeModal.close({ success: true });
        }
        else if (res.responseMessage === Enums.ErrorCodes.ErrorCode) {
          this.spinner.hide();
          this.toaster.error(errorMessage);
        }
  
      }, _error => {
        this.spinner.hide();
        this.toaster.error(errorMessage);
      });
    }
  }

  get cpf() {
    return this.editMechanicForm.controls;
  }

  public onChangeIsActive(_value: boolean) {
    this.mechanicInfo.isActive = !this.mechanicInfo.isActive;
  }

  public onChangecapacityPlanning(_value: boolean) {
    this.mechanicInfo.isCapacityPlanning = !this.mechanicInfo.isCapacityPlanning;
  }

  public onChangeConsiderCustomerWaitingSlots(_value: boolean) {
    this.mechanicInfo.isConsiderCustomerWaitingSlots = !this.mechanicInfo.isConsiderCustomerWaitingSlots;
  }

  public onChangeIsNotAvailable(_value: boolean)
  {
    this.mechanicInfo.isNotAvailable = !this.mechanicInfo.isNotAvailable;
  }

  public onChangeNotAvailableEndDate(event:any)
  {
    this.mechanicInfo.notAvailableEndDate=event;
  }

  OnClose(){
    this.activeModal.close({ success: true });
  }

}
